import { useSelector } from "react-redux";
import { isEqual } from "lodash-es";

import { selectFedwireTemplates, selectOneFedwireTemplate } from "./selectors";

export const useFedwireTemplates = () => {
  return useSelector(selectFedwireTemplates);
};

export const useOneFedwireTemplate = (
  fedwireTemplateId?: API.FedwireTemplateId,
) => {
  return useSelector((state) => {
    return selectOneFedwireTemplate(state, fedwireTemplateId);
  }, isEqual);
};
